import {useQueryWithAccessToken} from "../../../hooks/TanstackHooks";
import {cacheKeys} from "../../../services/shared/serviceConstants";
import {getInactiveUsers} from "../../../services/shared/InactiveUsers";
import {UserConfigTable} from "../../../components/common/Tables/UserConfigTable";
import React from "react";
import {getGridHeadingCount} from "../../../components/common/Tables/Utilities";

export const InactiveUsersPanel = () => {

  const {isLoading, data} = useQueryWithAccessToken({
    queryKey: [cacheKeys.inactiveUsers],
    queryFunction: getInactiveUsers,
    queryFunctionVariables:{}}
  );

  return <>
    {
        <UserConfigTable
          heading={getGridHeadingCount(data, 'Inactive Users')}
          users={data}
          shouldShowActionColumn={true}
          isLoading={isLoading}
        />
    }
  </>;
}